
export default {
  props: {
    color: {
      type: String,
      default: '#FFF'
    }
  }
}
